import React, { useState } from "react";
import { Star } from "lucide-react";

export default function StarRating({
    value = 0,
    onChange,
    size = 24,
    readOnly = false,
    color = "#FF3B30",
    testid = "star-rating",
}) {
    const [hover, setHover] = useState(0);
    const display = hover || value;
    return (
        <div className="flex items-center gap-1" data-testid={testid}>
            {[1, 2, 3, 4, 5].map((n) => {
                const filled = n <= display;
                return (
                    <button
                        key={n}
                        type="button"
                        disabled={readOnly}
                        onMouseEnter={() => !readOnly && setHover(n)}
                        onMouseLeave={() => !readOnly && setHover(0)}
                        onClick={() => !readOnly && onChange && onChange(n)}
                        className={`transition-transform ${
                            readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"
                        }`}
                        data-testid={`${testid}-star-${n}`}
                        aria-label={`${n} estrela${n > 1 ? "s" : ""}`}
                    >
                        <Star
                            style={{
                                width: size,
                                height: size,
                                color: filled ? color : "#D4D4D8",
                                fill: filled ? color : "transparent",
                            }}
                            strokeWidth={1.5}
                        />
                    </button>
                );
            })}
        </div>
    );
}
